import api from "@/assets/js/service/api";
import { LOGINURL } from "@/utils/apis";
import axios from "axios";
import { Message } from "element-ui";
import qs from "querystring";
// import store from '@/store'

const service = axios.create({
  baseURL: "/wxtapi/",
  timeout: 300000,
  withCredentials: true,
  // headers: {
  //   "Content-Type": "application/json",
  //   "X-Requested-With": "XMLHttpRequest",
  // },
});
// service.defaults.headers.post["Content-Type"] =
//   "application/x-www-form-urlencoded";
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    let isNotEquityPage = window.location.href.indexOf("/equity") == -1;
    let isNotSoftPage = window.location.href.indexOf("/soft") == -1;
    let isNotDocPackPage = window.location.href.indexOf("/docpack") == -1;
    let isNotLabLinkPage = window.location.href.indexOf("/lab/cj") == -1;
    // return res;
    if (
      res.code == 401 &&
      isNotEquityPage &&
      isNotSoftPage &&
      isNotDocPackPage &&
      isNotLabLinkPage
    ) {
      setTimeout(() => {
        window.location.href = LOGINURL;
      });
    } else if (res.code == 103) {
      // 用户不存在退出登录 https://wxt.xkw.com/introduce/index.html https://wxt.zxxk.com/
      setTimeout(() => {
        window.location.href = api.auth.logout + "?curl=https://wxt.zxxk.com/";
      });
    } else if (res.code == 104) {
      let href = window.location.href;
      // console.log("href", href, href.indexOf("/lab") > -1);
      if (
        href.indexOf("/lab/playreport") > -1 ||
        href.indexOf("/lab/visitreport") > -1 ||
        href.indexOf("/soft") > -1 ||
        href.indexOf("/docpack") > -1 ||
        href.indexOf("/lab/soft") > -1
      ) {
        return res;
        // setTimeout(() => {
        //   window.location.href = `https:///wxt.xkw.com/noAuth?schoolId=${res.result.message}`;
        // });
      } else {
        setTimeout(() => {
          window.location.href =
            href.indexOf("/lab") > -1
              ? "https://wxt.xkw.com/lab/introduce"
              : "https://wxt.xkw.com/introduce/index.html";
        });
      }
    } else if (
      res.code == 403 &&
      (window.location.href.indexOf("/lab/playreport") > -1 ||
        window.location.href.indexOf("/lab/visitreport") > -1)
    ) {
      setTimeout(() => {
        window.location.href = `https:///wxt.xkw.com/noAuth?schoolId=${res.result.message}`;
      });
    } else if (res.code == 500 || res.code == 502) {
      Message({
        message: "服务器错误" + res.code,
        type: "error",
        duration: 3 * 1000,
      });
    } else {
      return res;
    }
  },
  (error) => {
    console.log("error", error);
    if (!axios.isCancel(error)) {
      Message({
        message: error.message,
        type: "error",
        duration: 5 * 1000,
      });
    }
    return Promise.reject(error);
  }
);
// qs.stringify(params)
function post(url, params, isJson, cancelToken = false) {
  return new Promise((resolve, reject) => {
    const param = isJson ? params : qs.stringify(params);
    service
      .post(url, param, cancelToken ? { cancelToken } : {})
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}

/**
 * 发送入参为json格式的ajax请求
 * @param {*} url
 * @param {*} params
 * @returns
 */
function postJson(url, params, token = false) {
  // console.log("参数", params);
  return this.post(url, params, true, token);
}

/// /返回一个Promise(发送get请求)
// 因为new Promise声明的是异步函数，而且是为了ajax请求嵌套严重，而更加规范的一种书写方式;这里将Promise作为返回值给我们的公用函数
function get(rawUrl, params) {
  const url =
    rawUrl.indexOf("?") < 0
      ? rawUrl + "?_=" + new Date().getTime()
      : 'rawUrl + "&_=" + (new Date()).getTime()';
  return new Promise((resolve, reject) => {
    service
      .get(url, { params })
      .then(
        (response) => {
          // console.log("response-----", response);
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
// function getKeepAlive(rawUrl, params) {
//   const url =
//     rawUrl.indexOf("?") < 0
//       ? rawUrl + "?_=" + new Date().getTime()
//       : 'rawUrl + "&_=" + (new Date()).getTime()';
//   return new Promise((resolve, reject) => {
//     service({
//       method: "GET",
//       url,
//       kee
//       params,
//     })
//       .then(
//         (response) => {
//           resolve(response);
//         },
//         (err) => {
//           reject(err);
//         }
//       )
//       .catch((error) => {
//         reject(error);
//       });
//   });
// }
function downLoadBuffer(url, params, method = "GET") {
  // service.defaults.hea;
  return new Promise((resolve, reject) => {
    // const param = isJson ? params : qs.stringify(params);
    let finalParams =
      method == "GET"
        ? {
            method,
            url,
            responseType: "blob",
            params,
          }
        : {
            method,
            url,
            responseType: "blob",
            data: params,
          };
    service(finalParams)
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
//上传附件axios接口封装
const upload = {
  uploadFile(url, payload, cd) {
    return service({
      url: url,
      method: "post",
      data: payload,
      onUploadProgress: function (progressEvent) {
        if (progressEvent.lengthComputable) {
          cd(progressEvent);
        }
      },
    });
  },
};
const request = {
  get,
  post,
  postJson,
  upload,
  axios,
  downLoadBuffer,
  custom: (config) => {
    return service(config);
  },
};
export default request;
